import { render, staticRenderFns } from "./TeamManagement.vue?vue&type=template&id=ea201f96&scoped=true&"
import script from "./TeamManagement.vue?vue&type=script&lang=js&"
export * from "./TeamManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea201f96",
  null
  
)

export default component.exports